import { useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import useORScheduleData from '../../hooks/useORScheduleData'
import { AppChartCard } from '../@dashboard/app';
import { getUnitForPower } from '../../utils/apiCommonMethods';

const minHeightStyle = { minHeight: 320 };

export default function ORScheduleChart({
  site,
  startDate,
  endDate,
  msSessionInfo,
  expandContractChart,
  refreshKey,
}) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  const { loading, series = [] } = useORScheduleData({
    site,
    startDate,
    endDate,
    msSessionInfo,
    inView,
    refreshKey,
  });

  const hasData = useMemo(() => {
    if (!series || series.length === 0) return false;
   
    return series.some(s => (s?.data?.length ?? 0) > 0);
  }, [series]);

  if (!inView) {
    return <div ref={ref} style={minHeightStyle} />;
  }


  if (loading) {
    return (
      <div
        ref={ref}
        style={{ ...minHeightStyle, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <CircularProgress />
      </div>
    );
  }

  if (!hasData) {
    return <div ref={ref} style={minHeightStyle} />; 
  }

  
  return (
    <div ref={ref}>
      <AppChartCard
        title="Operating Reserves Schedules"
        subheader={`Power (${getUnitForPower(site?.id)})`}
        xAxisLabel="Hour Beginning"
        expandContractChart={expandContractChart}
        chartData={series}
        xMinMs={startDate?.valueOf()}
        xMaxMs={endDate?.valueOf()}
      />
    </div>
  );
}

ORScheduleChart.propTypes = {
  site: PropTypes.object.isRequired,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  msSessionInfo: PropTypes.object.isRequired,
  expandContractChart: PropTypes.func,
  refreshKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};